import { Component, Input, OnInit, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { isString } from 'lodash-es';
import { ApiV1Job } from '@bluecrew/crew-member-backend-angular-client';
import { ActiveDays } from '../working-days-of-week/working-days-of-week.component';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';
import { formatDateNoDay, formatTime, normalizeActiveDaysFromApiV1 } from 'src/app/util/format-utils';
dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  selector: 'app-schedule-detail',
  templateUrl: './schedule-detail.component.html',
  styleUrls: ['./schedule-detail.component.scss'],
})
export class ScheduleDetailComponent implements OnInit {

  startTime: string;
  endTime: string;
  startDate: string;
  endDate: string;
  singleShiftDotSvgPath: string = 'assets/icons/schedule-dot.svg';
  multiShiftDotSvgPath: string = 'assets/icons/connector.svg';

  @Input()
  get job(): ApiV1Job { return this._job; }
  set job(job: ApiV1Job) {
    this._job = job;
    const djtz = (t: string) => dayjs(t);
    this.startTime = formatTime(djtz(this.job.startTime));
    this.endTime = formatTime(djtz(this.job.endTime));
    this.startDate = formatDateNoDay(djtz(this.job.startTime));
    this.endDate = formatDateNoDay(djtz(this.job.endTime));
  }
  private _job: ApiV1Job;

  @Input()
  get shouldHighlight(): boolean { return this._shouldHighlight; }
  set shouldHighlight(shouldHighlight: boolean) {
    this._shouldHighlight = shouldHighlight
    if (this.shouldHighlight) {
      this.backgroundColor = '#3246F0';
      this.wageColor = '#FFFFFF';
      this.textColor = '#FFFFFF';
      this.border = '1px solid #3246F0'
      this.activeDaysOfWeekBackgroundColor = '#FFFFFF40'
      this.singleShiftDotSvgPath = 'assets/icons/schedule-dot-white.svg';
      this.multiShiftDotSvgPath = 'assets/icons/connector-white.svg';
    } else {
      this.backgroundColor = '#FFFFFF';
      this.wageColor = '#3246F0';
      this.textColor = '#080912';
      this.border = '1px solid #BABBC4'
      this.activeDaysOfWeekBackgroundColor = '#F2F3F7'
      this.singleShiftDotSvgPath = 'assets/icons/schedule-dot.svg';
      this.multiShiftDotSvgPath = 'assets/icons/connector.svg';
    }
  }
  private _shouldHighlight: boolean;

  @Input() displayWage?: boolean = true;
  @Input() wageColor?: string = '#3246F0';
  @Input() textColor?: string = '#080912';
  @Input() backgroundColor?: string = '#FFFFFF';
  @Input() activeDaysOfWeekBackgroundColor?: string = '#F2F3F7';
  @Input() border?: string = '1px solid #BABBC4';
  @Input() isSingleSchedule?: boolean = true;
  @Input() jobId: string;
  @Output() selectedJobCardEvent = new EventEmitter<number>();

  constructor() { }

  ngOnInit() {
  }

  getActiveDays(): ActiveDays {
    return normalizeActiveDaysFromApiV1(this.job.workdays);
  }

  isJobWageAString(wage: string | number) {
    return isString(wage);
  }

  getJobWageComponents(wage: number) {
    return wage.toFixed(2).split('.');
  }
}
